/**
 * Тип меток прогресс-бара.
 * ---
 * - 'minMidMax' - 3 метки под прогресс-баром (начальная, конечная и средняя);
 * - 'segments' - 2 метки под прогресс-баром (диапазон центрального сегмента).
 */
export enum ESegmentedProgressBarMarksType {
  minMidMax = 'minMidMax',
  segments = 'segments',
}
